// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.passwordReset_alertMessage__yxGm2 {
    display: flex;
    max-width: 384px;
    padding: 16px 12px;
    align-items: center;
    gap: 10px;
    border-radius: 4px;
    border: 1px solid #5151f9;
    background: #fff;
    color: #5151f9;
}
`, "",{"version":3,"sources":["webpack://./src/pages/passwordReset/passwordReset.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;AAClB","sourcesContent":[".alertMessage {\n    display: flex;\n    max-width: 384px;\n    padding: 16px 12px;\n    align-items: center;\n    gap: 10px;\n    border-radius: 4px;\n    border: 1px solid #5151f9;\n    background: #fff;\n    color: #5151f9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alertMessage": `passwordReset_alertMessage__yxGm2`
};
export default ___CSS_LOADER_EXPORT___;
